import * as Yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum K1893PurchaseOrderOVGLineItemKeys {
  itemNumber = 'itemNumber',
  description = 'description',
  externalItemNumber = 'externalItemNumber',
  eaUPC = 'eaUPC',
  size = 'size',
  qtyPerEach = 'qtyPerEach',
  caseSize = 'caseSize',
  caseQtyOrdered = 'caseQtyOrdered',
  caseCost = 'caseCost',
  lineTotal = 'lineTotal',
}

const K1893PurchaseOrderOVGLineItemSchema = Yup.object().shape({
  [K1893PurchaseOrderOVGLineItemKeys.itemNumber]: Yup.number().nullable().optional(),
  [K1893PurchaseOrderOVGLineItemKeys.description]: Yup.string().nullable().optional(),
  [K1893PurchaseOrderOVGLineItemKeys.externalItemNumber]: Yup.string().nullable().optional(),
  [K1893PurchaseOrderOVGLineItemKeys.eaUPC]: Yup.string().nullable().optional(),
  [K1893PurchaseOrderOVGLineItemKeys.size]: Yup.string().nullable().optional(),
  [K1893PurchaseOrderOVGLineItemKeys.qtyPerEach]: Yup.string().nullable().optional(),
  [K1893PurchaseOrderOVGLineItemKeys.caseSize]: Yup.string().nullable().optional(),
  [K1893PurchaseOrderOVGLineItemKeys.caseQtyOrdered]: Yup.string().nullable().optional(),
  [K1893PurchaseOrderOVGLineItemKeys.caseCost]: Yup.string().nullable().optional(),
  [K1893PurchaseOrderOVGLineItemKeys.lineTotal]: Yup.string().nullable().optional(),
})

export const K1893PurchaseOrderOVGFileDataSchema = Yup.object().shape({
  buyer: Yup.object()
    .shape({
      companyName: Yup.string().nullable().optional(),
      addressLine1: Yup.string().nullable().optional(),
      phoneNumber: Yup.string().nullable().optional(),
      emailAddress: Yup.string().nullable().optional(),
    })
    .required(),
  vendor: Yup.object()
    .shape({
      companyName: Yup.string().nullable().optional(),
      addressLine1: Yup.string().nullable().optional(),
      phoneNumber: Yup.string().nullable().optional(),
      emailAddress: Yup.string().nullable().optional(),
    })
    .required(),
  purchaseOrderNumber: Yup.string().nullable().optional(),
  dateIssued: Yup.string().nullable().optional(),
  dateReady: Yup.string().nullable().optional(),
  paymentTerms: Yup.string().nullable().optional(),
  freightTerms: Yup.string().nullable().optional(),
  destination: Yup.object()
    .shape({
      company: Yup.string().nullable().optional(),
      addressLine1: Yup.string().nullable().optional(),
      contactName: Yup.string().nullable().optional(),
      contactEmail: Yup.string().nullable().optional(),
      contactPhone: Yup.string().nullable().optional(),
    })
    .required(),
  items: Yup.array().of(K1893PurchaseOrderOVGLineItemSchema).required(),
  instructionsHeader: Yup.string().nullable().optional(),
  comments: Yup.string().nullable().optional(),
  vendorInstructions: Yup.string().nullable().optional(),
})

export type K1893PurchaseOrderOVGFileData = Yup.InferType<
  typeof K1893PurchaseOrderOVGFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<K1893PurchaseOrderOVGFileData>

export const k1893PurchaseOrderOVGFileMappings: RequiredFileData = {
  buyer: {
    companyName: 'c9a7ea4a-fef5-45d1-b59f-675e4b88a975',
    addressLine1: '4ac88bfc-5da5-435b-ab72-d35598a73da0',
    phoneNumber: 'a2bf8852-1cf6-45a5-8efb-fa05d47cccb5',
    emailAddress: '6a275354-e08b-49f2-a86d-8cf45d070c04',
  },
  vendor: {
    companyName: 'da303978-16c1-4cde-bbe1-42a2356641ac',
    addressLine1: '83ca525b-6613-488e-8742-87a69160dfd7',
    phoneNumber: '11dac1fd-da4b-43b3-ba02-29a9c94ff747',
    emailAddress: '7dcbd84f-9ba6-4771-994e-c89d89d74f0a',
  },
  purchaseOrderNumber: '23ef9597-e282-4280-93e8-c702550e255b',
  paymentTerms: '719c1375-597e-4736-a6cf-e2c669025262',
  freightTerms: '06d521a1-731b-4bec-ae25-f0435f210524',
  dateIssued: '9af849c1-87e2-4b1a-bc32-bf376edd13a0',
  dateReady: 'a7572c1c-7b72-46a9-bee9-baf7c67a02c6',
  destination: {
    company: '521235ea-bcaa-4fc4-9642-f3cd92e2b2b7',
    addressLine1: '0c41b348-063a-4927-b5f9-af6039076d3d',
    contactName: 'a9ca698d-4631-40f1-8127-ca27de9d086e',
    contactEmail: 'f24a34d5-fda5-4b69-bf02-ff2b2e9434bf',
    contactPhone: '365fd093-c2b4-4e93-8a7b-02cb81a6aaef',
  },
  instructionsHeader: '446edccb-de13-4b90-886e-e2a93f488953',
  comments: '787477e1-18ae-4d11-b8ef-d1ff8e09e641',
  vendorInstructions: '37ac267c-72b7-4ef1-95e3-09f46bffcee1',
  items: [
    {
      itemNumber: null,
      description: '337043f3-aa37-44d2-b300-de268d548ad8',
      externalItemNumber: '20e05e37-06da-4aef-bea8-2b3f1f19b66d',
      eaUPC: '900d92f9-c96e-4319-b446-f7d7819bb7ee',
      size: '3449a8bb-90a8-4da2-9406-016cbe4832fc',
      qtyPerEach: '2233fa9e-8be2-485c-a707-7388137bf2c0',
      caseSize: '3ffb460b-7ffd-46d6-8f21-30f540aff448',
      caseQtyOrdered: '0405cd10-73fc-4725-9500-63a8d1c870e9',
      caseCost: '75077d83-646b-419b-a6ca-28e068e3f8f0',
      lineTotal: null,
    },
  ],
}
